// extracted by mini-css-extract-plugin
export var dataCell = "_rj-2";
export var dataRow = "_rj-0";
export var headerRow = "_rj-1";